import React from 'react'
import { isEmpty } from 'libraries/lodash'
import CommentPanel from 'pages/comments/CommentPanel'

const CommentsList = ({
  comments,
  page,
  pageLength,
  category,
  preview,
  encryptionKeysLoaded,
  isFiltered,
  isAnnotationsLoaded,
  isCommentsLoaded
}) => {
  if (encryptionKeysLoaded && isFiltered && isAnnotationsLoaded && isCommentsLoaded && isEmpty(comments)) {
    return <div className='comment-list-empty'>Empty</div>
  }

  return comments && comments
    .slice((page - 1) * pageLength, page * pageLength)
    .map((comment, index, list) => (
      <CommentPanel
        key={comment.commentNode.id}
        {...{
          ...comment,
          previousReference: index > 0 ? list[index - 1].commentReference : null,
          commentCategory: category,
          commentPreview: preview,
          index,
          isLast: index === list.length - 1
        }}
      />
    ))
}

export default CommentsList
